import React from 'react'
import ConfiguratorAppContext from '../ConfiguratorAppContext'
import Button from '../components/Button'

import './DebugHeader.scss'
import { CheckBox } from '../components/CheckBox'
import { AppStateActions } from '../state/AppState'
import { isDebugModeAvailable } from './debugModeUtils'
import { setLocalStorageSavedState } from '../state/LocalStorageSavedState'
import { IconChevDown } from '../components/icons'
import { handleLogIn, handleLogOut } from '../utils/loginUtils'
import { ENABLE_SIMULATED_LOGIN_FLOW } from '../environment'

const OpenCloseChevron: React.FC<{
  open: boolean
}> = ({ open }) => {
  return (
    <img
      src={IconChevDown}
      alt=""
      style={{
        marginRight: '10px',
        transform: `rotate(${ open ? 270 : 90 }deg)`,
        filter: 'brightness(100)',
      }}
    />
  )
}

const DebugHeader = (props: {
  onClickDebugList: () => void
}) => {
  const context = React.useContext(ConfiguratorAppContext)

  const debugModeAvailable = isDebugModeAvailable()

  const { sharingListShown, debugMode, dispatch } = context

  if (!debugModeAvailable) {
    return null
  }

  return (
    // eslint-disable-next-line jsx-a11y/accessible-emoji
    <div className="DebugHeader">
      😎 Debug Mode

      <div
        style={{
          flex: '1 1 auto',
        }}
      />

      <CheckBox
        checked={debugMode}
        setChecked={() => dispatch({ action: AppStateActions.SetDebugEnabled, enabled: !debugMode })}
      >
        Show debug options
      </CheckBox>

      <div style={{ flex: '0 0 10px' }} />

      {ENABLE_SIMULATED_LOGIN_FLOW && (
        <>
          <Button
            buttonStyle="debug"
            round
            onClick={() => {
              if (window.confirm(context.isAuthenticated ? 'Do you want to log out?' : 'Do you want to log in?')) {
                if (context.isAuthenticated) {
                  handleLogOut()
                } else {
                  handleLogIn()
                }
              }
            }}
          >
            {context.isAuthenticated ? 'log out' : 'log in'}
          </Button>

          <div style={{ flex: '0 0 10px' }} />
        </>
      )}

      <Button
        buttonStyle="debug"
        round
        onClick={() => {
          if (window.confirm('Clear all local user data and start again?')) {
            setLocalStorageSavedState(null)
            // eslint-disable-next-line
            window.location = window.location
          }
        }}
      >
        reset
      </Button>

      <div style={{ flex: '0 0 10px' }} />

      <Button
        buttonStyle="debug"
        round
        onClick={props.onClickDebugList}
      >
        products
      </Button>

      <div style={{ flex: '0 0 10px' }} />

      <Button
        buttonStyle="debug"
        round
        onClick={context.onClickShareList}
      >
        <OpenCloseChevron open={sharingListShown} />
        list
      </Button>

      <Button
        buttonStyle="debug"
        round
        onClick={() => {
          // eslint-disable-next-line
          window.location.href = window.location.href
        }}
      >
        Reload
      </Button>
    </div>
  )
}

export default DebugHeader
